import { render, staticRenderFns } from "./autoAddNewData.vue?vue&type=template&id=531eb48d&scoped=true"
import script from "./autoAddNewData.vue?vue&type=script&lang=js"
export * from "./autoAddNewData.vue?vue&type=script&lang=js"
import style0 from "./autoAddNewData.vue?vue&type=style&index=0&id=531eb48d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531eb48d",
  null
  
)

export default component.exports